export class Serializable {
  fillFromJSON(jsonObj: any) {
    for (let propName in jsonObj) {
      this[propName] = jsonObj[propName];
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/myria/app/serializable.ts